import { SLIDE_ADAPTER } from '@src/framework/workbench/editor-adpater/slide-adapter';
import { ChartModelFactory } from '@src/slide/domain/ui-model/element-modeles/chart-models/chart-presets/chart-model-factory';
import { PresetChartType } from '@src/slide/domain/ui-model/element-modeles/chart-models/chart-presets/const';
import i18n from '@i18next/i18n';
import { IChartTypeFeature, STChartType } from '@tencent/chart-drawer-components/lib/interface';
import Snackbar from '@tencent/dui/lib/components/Snackbar';
import { Feature } from '@tencent/workbench';
import ChartBaseDrawerFeature from '@src/framework/workbench/drawer/ui/chart/chart-base-drawer-feature';
import { chartTypeMapping } from '../../utils';
import _isNil from 'lodash/isNil';

import './index-global.less';

const commonSnackbarConfig: Parameters<typeof Snackbar.show>[0] = {
    type: 'warning',
    duration: 5000,
};

@Feature({
    name: 'ChartTypeSelectFeature',
    adapters: [SLIDE_ADAPTER],
    provide: IChartTypeFeature,
})
export class ChartTypeSelectFeature extends ChartBaseDrawerFeature implements IChartTypeFeature {
    /**
     * 设置图表类型
     */
    public setChartType = (type: STChartType): void => {
        if (!this.isChartValid(type)) {
            return;
        }
        const slideChartType = chartTypeMapping[type];
        const model = this.getSelectModel();
        if (model && !_isNil(slideChartType)) {
            ChartModelFactory.modifyChartType(model, slideChartType);
        }
    };

    /**
     * 判断当前图表是否有效，如果无效则弹出提示并返回 false，中断图表类型切换
     * @param type 图表类型
     * @param series 图表所有的系列配置
     */
    private isChartValid = (type: STChartType): boolean => {
        if (chartTypeMapping[type] === PresetChartType.SCATTER
            || chartTypeMapping[type] === PresetChartType.BUBBLE
            || chartTypeMapping[type] === PresetChartType.STOCK
            || chartTypeMapping[type] === PresetChartType.COMBO) {
            Snackbar.show({
                ...commonSnackbarConfig,
                message: i18n.t('暂不支持修改成该类型的图表'),
            });
            return false;
        }

        return true;
    };
}
